// src/CreateNotification.js
import React, { useState } from 'react';
import './Messages.css';
import { Link } from 'react-router-dom';

const Messages = () => {
  const [title, setTitle] = useState('');
  const [category, setCategory] = useState('');
  const [avatar, setAvatar] = useState(null);
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you can add the code to handle form submission
    console.log({ title, category, avatar, message });
  };

  return (

    
    
      <div>
        <h2 className="notification-heading">Create New Notification</h2>
        <form onSubmit={handleSubmit} className="notification-form">
          <div className="form-group">
            <label>Notification Title</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter title"
            />
          </div>
          <div className="form-group">
            <label>Notification Category</label>
            <select value={category} onChange={(e) => setCategory(e.target.value)}>
              <option value="">Select Category</option>
              <option value="update">Update</option>
              <option value="alert">Alert</option>
              <option value="reminder">Reminder</option>
            </select>
          </div>
          <div className="form-group">
            <label>Upload Avatar</label>
            <input type="file" onChange={(e) => setAvatar(e.target.files[0])} />
          </div>
          <div className="form-group">
            <label>Message</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Enter message"
            />
          </div>
          <button type="submit" className="send-btn">SEND</button>
        </form>
      </div>
  );
};

export default Messages;
